import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { useTranslation } from 'react-i18next';
import { Step } from '../../../../../components/Step';

export const Step6 = () => {
  const { t } = useTranslation('settings');

  return (
    <Step
      title={`${t('integrations.step')} 6`}
      subtitle={t('integrations.factorial.review the data in the view edit employees section')}
      Icon={PersonSearchIcon}
    />
  );
};
